import { useEffect, useState } from "react";
import SectionStyleFour from "../Helpers/SectionStyleFour";
import SectionStyleOne from "../Helpers/SectionStyleOne";
import SectionStyleThree from "../Helpers/SectionStyleThree";
import SectionStyleTwo from "../Helpers/SectionStyleTwo";
import ViewMoreTitle from "../Helpers/ViewMoreTitle";
import Layout from "../Partials/Layout";
import Banner from "./Banner";
import BestSellers from "./BestSellers";
import BrandSection from "./BrandSection";
import CampaignCountDown from "./CampaignCountDown";
import { ErrorToaster } from "../Helpers/toaster/Toaster";
import ProductServices from "../../apis/product/ProductServices";
import ShopServices from "../../apis/shop/ShopServices";
import CommonServices from "../../apis/common/CommonServices";
import Categories from "./Categories";
import CategoryServices from "../../apis/category/CategoryServices";
import SelectStoreModal from "../Helpers/Modal/SelectStoreModal";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default function Home() {

  // *For Products
  const [products, setProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);

  // *For Brands
  const [brands, setBrands] = useState([]);
  const [brandBaseUrl, setBrandBaseUrl] = useState();

  // *For Top Selling Products
  const [topSellingProducts, setTopSellingProducts] = useState([]);

  // *For Top Seller
  const [topSeller, setTopSeller] = useState([]);
  const [sellerImageBaseUrl, setSellerImageBaseUrl] = useState();

  // *For Flash Sales
  const [flashSales, setFlashSales] = useState([]);
  const [saleBaseUrl, setSaleBaseUrl] = useState([]);

  // *For Campaigns
  const [campaignsBanner, setCampaignsBanner] = useState([]);

  // *For Categories
  const [categories, setCategories] = useState([]);
  const [fullBaseUrl, setFullBaseUrl] = useState('');

  // *For Load More Loading
  const [loading, setLoading] = useState(false);
  const [currentProductPage, setCurrentProductPage] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);

  const [openDialog, setOpenDialog] = useState(false);
  const [productId, setProductId] = useState();

  // *For Promotions
  const [promotionsOne, setPromotionsOne] = useState([]);
  const [promotionsTwo, setPromotionsTwo] = useState([]);
  const [promotionsThree, setPromotionsThree] = useState([]);
  const [promotionsFour, setPromotionsFour] = useState([]);
  const [promotionsFive, setPromotionsFive] = useState([]);
  const [promotionsSix, setPromotionsSix] = useState([]);
  const [promotionsSeven, setPromotionsSeven] = useState([]);

  // *For Get Products
  const getProducts = async (page, limit) => {
    setLoading(true)
    try {
      let params = {
        search: '',
        page: page,
        limit: 30
      }
      setCurrentProductPage(page)
      const { data, count } = await ProductServices.getProducts(params)
      if (page === 1) {
        setProducts(data)
      } else {
        setProducts([...products, ...data])
      }
      setTotalProducts(count)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  // *For Get Brands
  const getBrands = async () => {
    try {
      let params = {
        search: '',
        page: 1,
        limit: 12
      }
      const { imageBaseUrl, data } = await ProductServices.getBrands(params)
      setBrands(data)
      setBrandBaseUrl(imageBaseUrl)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Top Selling Products
  const getTopSellingProducts = async () => {
    try {
      let params = {
        search: '',
        page: 1,
        limit: 6
      }
      const { data } = await ProductServices.getTopSellingProducts(params)
      setTopSellingProducts(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Featured Products
  const getFeaturedProducts = async () => {
    try {
      let params = {
        search: '',
        page: 1,
        limit: 12,
        is_feature: 1
      }
      const { data } = await ProductServices.getProducts(params)
      setFeaturedProducts(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Top Seller
  const getTopSellers = async () => {
    try {
      let params = {
        search: '',
        page: 1,
        limit: 6
      }
      const { data, userImageBaseUrl } = await ShopServices.getTopSellers(params)
      setTopSeller(data)
      setSellerImageBaseUrl(userImageBaseUrl)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Flash Sale
  const getFlashSales = async () => {
    try {
      const { data, imageBaseUrl } = await CommonServices.getFlashSales()
      setFlashSales(data)
      setSaleBaseUrl(imageBaseUrl)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Campaigns
  const getCampaigns = async () => {
    try {
      const { data, imageBaseUrl } = await CommonServices.getCampaigns()
      const campImage = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        campImage.push(imageBaseUrl + element?.images[0]?.image_path)
      }
      if (campImage.length > 0) {
        setCampaignsBanner(campImage)
      } else {
        setCampaignsBanner([`${process.env.PUBLIC_URL}/assets/images/campaign-banner.jpeg`])
      }

    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Promotion
  const getPromotions = async () => {
    try {
      const { data, imageBaseUrl } = await CommonServices.getPromotions()
      const adOne = []
      const adTwo = []
      const adThree = []
      const adFour = []
      const adFive = []
      const adSix = []
      const adSeven = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element?.banner_area == 'Home 1') {
          adOne.push({ ...element, image: imageBaseUrl + element?.image })
        } else if (element?.banner_area == 'Home 2') {
          adTwo.push({ ...element, image: imageBaseUrl + element?.image })
        } else if (element?.banner_area == 'Home 3') {
          adThree.push({ ...element, image: imageBaseUrl + element?.image })
        } else if (element?.banner_area == 'Home 4') {
          adFour.push({ ...element, image: imageBaseUrl + element?.image })
        } else if (element?.banner_area == 'Home 5') {
          adFive.push({ ...element, image: imageBaseUrl + element?.image })
        } else if (element?.banner_area == 'Home 6') {
          adSix.push({ ...element, image: imageBaseUrl + element?.image })
        } else if (element?.banner_area == 'Home 7') {
          adSeven.push({ ...element, image: imageBaseUrl + element?.image })
        }
      }

      setPromotionsOne(adOne.length > 0 ? adOne : [{ url: '', image: `${process.env.PUBLIC_URL}/assets/images/ads-banner/ad-space-530X280.jpg` }])
      setPromotionsTwo(adTwo.length > 0 ? adTwo : [{ url: '', image: `${process.env.PUBLIC_URL}/assets/images/ads-banner/ad-space-530X280.jpg` }])
      setPromotionsThree(adThree.length > 0 ? adThree : [{ url: '', image: `${process.env.PUBLIC_URL}/assets/images/ads-banner/ad-space-630X460.jpg` }])
      setPromotionsFour(adFour.length > 0 ? adFour : [{ url: '', image: `${process.env.PUBLIC_URL}/assets/images/ads-banner/ad-space-630X295.jpg` }])
      setPromotionsFive(adFive.length > 0 ? adFive : [{ url: '', image: `${process.env.PUBLIC_URL}/assets/images/ads-banner/ad-space-630X295.jpg` }])
      setPromotionsSix(adSix.length > 0 ? adSix : [{ url: '', image: `${process.env.PUBLIC_URL}/assets/images/ads-banner/ad-space-1300X325.jpg` }])
      setPromotionsSeven(adSeven.length > 0 ? adSeven : [{ url: '', image: `${process.env.PUBLIC_URL}/assets/images/ads-banner/ad-space-1300X182.jpg` }])
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Get Categories
  const getCategories = async () => {
    try {
      let params = {
        search: '',
        page: 1,
        limit: 12
      }
      const { data, imageBaseUrl } = await CategoryServices.getCategories(params)
      setFullBaseUrl(imageBaseUrl)
      setCategories(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0 })
    getProducts(1);
    getBrands();
    getTopSellingProducts();
    getFeaturedProducts();
    getTopSellers();
    getFlashSales();
    getCampaigns();
    getCategories();
    getPromotions();
  }, []);

  return (
    <>
      <SelectStoreModal open={openDialog} close={() => setOpenDialog(false)} productId={productId} />

      <Layout>
        {/* {ads && <Ads handler={adsHandle} />} */}
        {/* <div className="btn w-5 h-5 "></div> */}
        <Banner
          className="banner-wrapper mb-[30px]"
          campaigns={campaignsBanner}
          promotionsOne={promotionsOne}
          promotionsTwo={promotionsTwo}
        />
        <ViewMoreTitle
          className="best-sallers-section mb-[30px]"
          // seeMoreUrl="/sellers"
          categoryTitle="Categories"
          viewMore={false}
        >
          <Categories
            data={categories}
            baseUrl={fullBaseUrl}
          />
        </ViewMoreTitle>
        <div id="new-arrivals">
          <SectionStyleThree
            openStoreList={(id) => { setOpenDialog(true); setProductId(id) }}
            products={products}
            sectionTitle="New Arrivals"
            seeMoreUrl="/all-products"
            className="new-products mb-[30px]"
          />
        </div>
        {/* <SectionStyleOne
          products={products}
          categoryTitle="Mobile & Tablet"
          sectionTitle="All Products"
          seeMoreUrl="/all-products"
          className="category-products mb-[30px]"
        /> */}
        <BrandSection
          sectionTitle="Brands Who Trust Us"
          className="brand-section-wrapper mb-[30px]"
          data={brands}
          baseUrl={brandBaseUrl}
        />
        <CampaignCountDown
          className="mb-[30px]"
          data={flashSales}
          saleBaseUrl={saleBaseUrl}
          promotionsThree={promotionsThree}
        />
        {/* <div id="top-selling">
          <ViewMoreTitle
            className="top-selling-product mb-[30px]"
            seeMoreUrl="/all-products"
            categoryTitle="Top Selling Products"
          >
            <SectionStyleTwo
              openStoreList={(id) => { setOpenDialog(true); setProductId(id) }}
              products={topSellingProducts}
            />
          </ViewMoreTitle>
        </div> */}
        <div id="top-seller">
          <ViewMoreTitle
            className="best-sallers-section mb-[30px]"
            seeMoreUrl="/sellers"
            categoryTitle="Best Seller"
          >
            <BestSellers data={topSeller} sellerImageBaseUrl={sellerImageBaseUrl} />
          </ViewMoreTitle>
        </div>
        <div className={`w-full products-ads-section mb-[30px]`}>
          <div className="container-x mx-auto">
            <div
              className={`sm:h-[295px] h-full sm:flex xl:space-x-[30px] sm:space-x-5 items-center w-full overflow-hidden`}
            >
              <div
                data-aos="fade-right"
                className={`h-full sm:mb-0 mb-5 sm:w-1/2 w-full`}
              >
                <Swiper
                  spaceBetween={10}
                  pagination={{
                    clickable: true,
                    dynamicBullets: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  lazy={true}
                  modules={[Autoplay, Pagination]}
                  className="mySwiper6"
                >
                  {promotionsFour?.map((promotion, index) => (
                    <SwiperSlide key={index}>
                      <a href={promotion?.url || ''} target='_blank' rel='noopener noreferrer'>
                        <img
                          src={promotion?.image}
                          alt=""
                          loading="lazy"
                        />
                      </a>
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div data-aos="fade-left" className="h-full sm:mb-0 mb-5 sm:w-1/2 w-full">
                <Swiper
                  spaceBetween={10}
                  pagination={{
                    clickable: true,
                    dynamicBullets: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  lazy={true}
                  modules={[Autoplay, Pagination]}
                  className="mySwiper7"
                >
                  {promotionsFive?.map((promotion, index) => (
                    <SwiperSlide key={index}>
                      <a href={promotion?.url || ''} target='_blank' rel='noopener noreferrer'>
                        <img
                          src={promotion?.image}
                          alt=""
                          loading="lazy"
                        />
                      </a>
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        {featuredProducts?.length > 0 &&
          <div style={{ backgroundColor: '#2343860f', padding: '20px 0px', marginBottom: '20px' }}>
            <SectionStyleOne
              openStoreList={(id) => { setOpenDialog(true); setProductId(id) }}
              categoryBackground={`${process.env.PUBLIC_URL}/assets/images/section-category-2.jpg`}
              products={featuredProducts}
              categoryTitle="Electronics"
              sectionTitle="Featured Products"
              seeMoreUrl="/all-products"
              className="category-products mb-[30px]"
            />
          </div>
        }
        <div className={`w-full products-ads-section mb-[30px]`}>
          <div className="container-x mx-auto">
            <div
              className={`items-center w-full  overflow-hidden`}
            >
              <div
                data-aos="fade-right"
                className={`h-full sm:mb-0 mb-5 w-full`}
              >
                <Swiper
                  spaceBetween={0}
                  pagination={{
                    clickable: true,
                    dynamicBullets: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  lazy={true}
                  modules={[Autoplay, Pagination]}
                  className="mySwiper8"
                >
                  {promotionsSix?.map((promotion, index) => (
                    <SwiperSlide key={index}>
                      <a href={promotion?.url || ''} target='_blank' rel='noopener noreferrer'>
                        <img
                          src={promotion?.image}
                          alt=""
                          loading="lazy"
                        />
                      </a>
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        <SectionStyleOne
          openStoreList={(id) => { setOpenDialog(true); setProductId(id) }}
          products={products}
          categoryTitle="Mobile & Tablet"
          sectionTitle="All Products"
          seeMoreUrl="/all-products"
          className="category-products mb-[30px]"
          loadMore={() => getProducts(currentProductPage + 1)}
          loading={loading}
          totalProducts={totalProducts}
          viewMore={true}
        />
        <div className={`w-full products-ads-section mb-[40px]`}>
          <div className="container-x mx-auto">
            <div
              className={`items-center w-full  overflow-hidden`}
            >
              <div
                data-aos="fade-right"
                className={`h-full sm:mb-0 mb-5 w-full`}
              >
                <Swiper
                  spaceBetween={0}
                  pagination={{
                    clickable: true,
                    dynamicBullets: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  lazy={true}
                  modules={[Autoplay, Pagination]}
                  className="mySwiper9"
                >
                  {promotionsSeven?.map((promotion, index) => (
                    <SwiperSlide key={index}>
                      <a href={promotion?.url || ''} target='_blank' rel='noopener noreferrer'>
                        <img
                          src={promotion?.image}
                          alt=""
                          loading="lazy"
                        />
                      </a>
                      <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        {/* <SectionStyleFour
          products={productss}
          sectionTitle="Popular Sales"
          seeMoreUrl="/all-products"
          className="category-products mb-[60px]"
        /> */}
      </Layout>
    </>
  );
}
